import React from "react";
import { View, StyleSheet } from "react-native";
import { useTheme } from "../../context/ThemeContext";

/**
 * Top-level app shell (Direction C).
 *
 * Two floating cards (sidebar + main) on a darker canvas. Main card shares
 * the sidebar's surface color so they read as one visual family, with just
 * the 12px canvas gap separating them. The subtle `borderSoft` edge matches
 * the reference design.
 */
function NtAppShell({ sidebar, children }) {
  const { theme } = useTheme();
  const styles = makeStyles(theme);

  return (
    <View style={styles.canvas}>
      {sidebar ? <View style={styles.sidebarSlot}>{sidebar}</View> : null}
      <View style={styles.mainCard}>{children}</View>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    canvas: {
      flex: 1,
      flexDirection: "row",
      gap: 12,
      padding: 12,
      backgroundColor: t.bg,
    },
    sidebarSlot: {
      width: 244,
      backgroundColor: t.surface,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radiusCard,
      overflow: "hidden",
    },
    mainCard: {
      flex: 1,
      backgroundColor: t.surface,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radiusCard,
      overflow: "hidden",
    },
  });

export default NtAppShell;
